<template>
  <div id="app" :class="{'batch': $route.query.batchPrint}">
    <router-view v-wechat-title="$route.meta.title" ></router-view>
    <el-backtop ></el-backtop>
    <!-- <GlobalWCS :callback="WCSisok" ref="GlobalWCS" /> -->
    <!-- <img :src="url" alt="" style="position: fixed;top: 100px;left: 100px;z-index: 10000"> -->
  </div>
</template>

<script>
//import GlobalWCS from '@/components/WCSVideo/GlobalWCS'
import resizeMixin from '@/mixin/resize'
import { getNeedCardCategory, saveQyCateCard, getNeedZhengmingCategory, saveZhengmingCard } from '@/api/company'
import Certificate from '@/utils/certificate'
import CertificatePx from '@/utils/certificatePx'
import Pxzmcertificatejg from '@/utils/pxzmcertificatejg'
import { mapGetters } from 'vuex'
export default {
  name: 'App',
  mixins: [resizeMixin],
  // components: {GlobalWCS},
  data() {
    return{
      url: ''
    }
  },
  computed: {
    ...mapGetters(['userInfo'])
  },
  mounted() {
    if (this.userInfo.role == 0 || this.userInfo.role == 3) {
      this.getNeedCardCategoryFunc()
      this.getNeedZhengmingCategoryFunc()
    }
    setInterval(() => {
      if (this.userInfo.role == 0 || this.userInfo.role == 3) {
        this.getNeedCardCategoryFunc()
        this.getNeedZhengmingCategoryFunc()
      }
    }, 60000)
    // new CertificatePx({
    //               name: 'xx',
    //               category_name: '有限空间岗位1',
    //               companyName: '无锡市安泰安全技术服务有限公司1',
    //               IDNo: '32323232323123123213',
    //               pxDate: '3030-30-03', // item  res.data.data.time_px
    //               bottomDate: '3030-30-03', // item  res.data.data.time_fx
    //                 }, (src) => {
    //                     this.url = src
    //                 })
      
  },
  methods:{
    WCSisok(){
      window.sessionStorage.setItem('antaiWcIsOk','1')
    },
    getNeedCardCategoryFunc() {
        getNeedCardCategory({ IdNum: this.userInfo.IdNum }).then(res => {
            res = res.data
            if (res.status == 1) {
                res.data = res.data || []
                const currentDate = new Date()
                // res.data = [
                //   { typef: 'QY', uname: '王海芬', category_name: ' 2022年全员培训->构成双重预防管控 2022年全员培训->构成双重预防管控', time_jhpx: '2020-1-1',  publish_organ: '南方事又'}
                // ]
                res.data.forEach(item => {
                  if (item.typef == 'QY') {
                    new Certificate(
                      item.uname || this.userInfo.uname, 
                      item.category_name, 
                      item.time_jhpx || `${currentDate.getFullYear()}-${currentDate.getMonth() + 1}-${currentDate.getDate()}`, 
                        item.publish_organ || item.compname, null, (src) => {
                          this.saveQyCateCardFunc(item, src)
                          // this.url = src
                    })
                  } else {
                    const time = `${currentDate.getFullYear()}-${currentDate.getMonth() + 1}-${currentDate.getDate()}`
                    new CertificatePx({
                          name: item.uname || this.userInfo.uname,
                          companyName: item.compname,
                          category_name: item.category_name,
                          IDNo: item.IdNum,
                          pxDate: res.data.time_jhpx || time,
                          bottomDate: res.data.time_jhpx || time,
                          publish_organ: item.publish_organ
                          }, (src) => {
                            this.saveQyCateCardFunc(item, src)
                        })
                  }
                })
            }
        })
    },
    saveQyCateCardFunc(item, src) {
        saveQyCateCard({
            ...item,
            compname: this.userInfo.compname,
            uname: this.userInfo.uname,
            content: src
        })
    },
    getNeedZhengmingCategoryFunc() {
        getNeedZhengmingCategory({ IdNum: this.userInfo.IdNum }).then(res => {
            res = res.data
            // res = {"msg":"成功","data":[{"type_zhuncaotext":"低压电工作业","category_name":"低压电工作业","uname":"王海峰","type_pxtext":"初训","year":"2022","zhengming_status":0,"bmid":53413,"card_status":1,"uid":55392,"type_zuoyetext":"电工作业","category_id":161,"odtypename":"特种作业人员","time_px":"2022-10-17","addtime":1667981866,"sfzheader":"https://peixun.safety365.com.cn/data/imgsfz/2022/09/SF20220915084528694.png","typef":"pxjg","IdNum":"320283199805074216","pbd_id":50818,"id":12,"publish_organ":"无锡市安泰安全技术服务有限公司","compname":"无锡安泰安全技术服务有限公司","times_study":51}],"status":1}
            if (res.status == 1) {
                res.data = res.data || []
                res.data.forEach(item => {
                  if (item.typef == "pxjg") {
                    new Pxzmcertificatejg(
                     item, (src) => {
                        // this.url = src
                        this.saveZhengmingCardFunc(item, src)
                    })
                  }
                })
            }
        })
    },
   saveZhengmingCardFunc(item, src) {
        saveZhengmingCard({
            ...item,
            compname: this.userInfo.compname,
            uname: this.userInfo.uname,
            content: src
        })
    },
  }
}
</script>
<style lang="scss">
.el-button--text {
  padding-left: 0 !important;
  padding-right: 0 !important;
}
</style>
